<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">Journey Access App</h2>
    </a>
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img class="img-fluid" [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/login-v2-dark.svg'
              : 'assets/images/pages/login-v2.svg'
          " alt="Login V2" />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Login-->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">¡Bienvenido a Journey Access App! 👋</h2>
        <p class="card-text mb-2">Inicie sesión en su cuenta y comience la aventura</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <input type="file" class="file-input" accept="application/json,text/json,application/octet-stream"
          (change)="getFile($event); fileUpload.value='' " #fileUpload>

        <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect
          (click)="fileUpload.click()">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Cargar llave de acceso
        </button>
        <p class="text-center mt-2">
          <a routerLink="/authentication/request-access-file"><span>&nbsp;Generar llave de acceso</span></a>
        </p>
      </div>
    </div>
    <!-- /Login-->
  </div>
</div>